import styled from 'styled-components'
import { deviceMax } from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import Button from '../Button/Button'

export const StyledSkipLinks = styled.nav`
  z-index: 10;
  gap: ${pxToRem(20)};
  top: ${({ $isVisible }) => ($isVisible ? pxToRem(80) : pxToRem(-80))};
  left: 0;
  right: 0;
  position: absolute;
  display: flex;
  transition: transform 0.3s;
  padding: 0 ${pxToRem(20)};
  background-color: ${({ theme }) => theme.colors.unique.white};

  @media ${deviceMax.tablet} {
    top: ${({ $isVisible }) => ($isVisible ? pxToRem(50) : pxToRem(-100))};
  }

  @media ${deviceMax.mobileL} {
    top: ${({ $isVisible }) => ($isVisible ? pxToRem(50) : pxToRem(-300))};
    align-items: center;
    flex-direction: column;
    display: flex;
    padding: ${pxToRem(20)} 0;
  }
`

export const StyledLink = styled(Button)``
